import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input, OnChanges,
    OnDestroy,
    Output,
    Renderer2, SimpleChanges,
    ViewChild
} from '@angular/core';
import {FileUploadService} from "../../services/file-upload.service";
import {HttpHeaders, HttpResponse} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {SessionService} from "../../../session/session.service";
import {InterfaceProviderService} from "../../../basic-entity-back/services/interface-provider.service";
import {BehaviorSubject, Subject, Subscription} from "rxjs";
import {debounceTime, finalize} from "rxjs/operators";
import {ObjViewerService} from "../../../services/obj-viewer.service";
import * as JSZip from "jszip";
import {esBasuraDeZip, extraerImagenesDeZip, tieneExtensionDeModelo3D, ZipImagenesError} from "../../services/zip-imagenes";

@Component({
    selector: 'be-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements AfterViewInit, OnDestroy, OnChanges {

    progress = 0;
    progressType = '';
    message = '';
    isArray = false;

    private removeSubscription = new BehaviorSubject<boolean>(false);
    private subscriptions: Subscription[] = [];

    @ViewChild('objViewer') objViewer: ElementRef;
    @ViewChild('lineaArchivo') lineaArchivo: ElementRef;
    @Input() buttonName = '';
    @Input() listaArchivos: any[] = [];
    @Output() public fileUploadedEmmiter = new EventEmitter<any[]>();
    @Output() public fileRemovedEmitter = new EventEmitter<any>();
    @Output() public seleccionEmmiter = new EventEmitter<any>();
    @Input() mostrarVisor = true;
    @Input() seleccionarPrimero = true;
    @Input() archivoSeleccionado: any = null;
    @Input() archivoSiguiente: any = null;
    @Input() disableButton = false;
    @Input() modelType = null;
    @Input() parentModelType = null;
    @Input() multiple: boolean = true;
    @Input() actualizarVisor = new BehaviorSubject<boolean>(false);
    /**
     * Opt-in: el icono de borrar solo avisa al padre (fileRemovedEmitter) y no borra nada. El padre
     * pregunta, borra y actualiza la lista. Sin esto el archivo se borraba en la API al pulsar el icono,
     * antes de que el padre preguntara, y CANCELAR ya no lo recuperaba.
     */
    @Input() confirmarBorrado = false;
    /**
     * Zonas de intraorales: de un ZIP se suben además las imágenes que lleve dentro, como si se hubieran subido
     * sueltas (ver zip-imagenes.ts). Las demás zonas (STL de pedidos, blender) no cambian.
     */
    @Input() extraerImagenesZip = false;
    /**
     * Lecturas de ZIP y subidas aún en marcha. Con extraerImagenesZip, al padre se le avisa cuando acaban todas: el
     * nuevo pedido enseña SIGUIENTE en cuanto la lista tiene algo, y crear la solicitud con la lista a medias dejaba
     * sin enganchar las imágenes que aún se estaban subiendo.
     */
    private pendientes = 0;
    private destruido = false;
    /** Por qué no se han subido las imágenes de un ZIP. Aparte de `message`, que cada subida vacía al empezar. */
    avisoZip = '';
    private clicked = new Subject<any>();
    private urlFile = environment.uploaderUrl;
    seleccionando = false;
    cambio = new BehaviorSubject<any[]>([]);
    @Input() tiposArchivoSoportados: string[] = ['*'];
    archivosSoportados: string = '';

    constructor(private uploadService: FileUploadService, private sessionService: SessionService, private interfaceProvider: InterfaceProviderService,
                private readonly _objViewerService: ObjViewerService, private readonly _renderer: Renderer2) {

        let params = new HttpHeaders();
        params = params.append('Authorization', 'Bearer ' + sessionService.token.token);
        this.uploadService.setBaseUrl(this.urlFile);
        this.uploadService.setRequestHeaders(params);
        this.uploadService.progressCompressObserver.subscribe(percent => {
            this.progress = percent;
            this.progressType = 'Comprimido';
        });
        this.uploadService.progressUploadObserver.subscribe(percent => {
            this.progress = percent;
            this.progressType = 'Subido';
        });
        this.removeSubscription.subscribe(result => {
            if (result) {
                this.subscriptions.forEach(sus => sus.unsubscribe());
            }
        })
        this.cambio.subscribe(result => {
            console.log(result)
        })
    }

    ngAfterViewInit(): void {
        if (this.tiposArchivoSoportados && this.tiposArchivoSoportados.length > 0) {
            this.archivosSoportados = this.tiposArchivoSoportados.join(',');
            this.archivosSoportados += this.tiposArchivoSoportados.map(a => a.toUpperCase()).join(',');
        }

        if (this.mostrarVisor) {
            this._objViewerService.iniciarEscena(this._renderer, this.objViewer.nativeElement);

            this.actualizarVisor.subscribe(actualizar => {
                if (actualizar) {
                    if (!this._objViewerService.escenaIniciada()) {
                        this._objViewerService.iniciarEscena(this._renderer, this.objViewer.nativeElement);
                    }

                    if (this.archivoSeleccionado) {
                        const url = this.urlFile + '/' + this.archivoSeleccionado.id + '/descargar';
                        if (this.mostrarVisor) {
                            this._objViewerService.loadObj(url, this.archivoSeleccionado.nombreFichero);
                        }
                    }
                }
            })
        }


        // Para evitar el doble click en el objeto
        const buttonClickedDebounced = this.clicked.pipe(debounceTime(350));
        buttonClickedDebounced.subscribe((archivo: any) => {
            this.enviarSeleccion(archivo)
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disableButton) {
            this.disableButton = changes.disableButton.currentValue;
        }

        if (changes.archivoSeleccionado && (changes.archivoSeleccionado.previousValue !== changes.archivoSeleccionado.currentValue && changes.archivoSeleccionado.currentValue !== undefined)) {
            this.actualizarVisor.next(true);
        }

        if (changes.listaArchivos && changes.listaArchivos.currentValue && changes.listaArchivos.currentValue.length === 0 && this.objViewer) {
            this._objViewerService.limpiarObj();
        }

        if (changes.modelType && changes.modelType.currentValue && changes.modelType.currentValue !== changes.modelType.previousValue) {
            this.modelType = changes.modelType.currentValue;
            this.urlFile = this.modelType ? environment.apiUrl + '/' + this.interfaceProvider.interfaceForModel(this.modelType).endpoint : environment.uploaderUrl;
            this.uploadService.setBaseUrl(this.urlFile);
        }
    }

    ngOnDestroy(): void {
        this.destruido = true;
        // this._objViewerService.limpiarEscena();
        this.subscriptions.forEach(sus => sus.unsubscribe());
    }

    selectFile(event: any): void {
        this.seleccionando = true;
        if (event.target.files && event.target.files.length > 0) {
            const fileListAsArray = Array.from(event.target.files);
            fileListAsArray.forEach((file: File) => {
                if (file.name.toLowerCase().endsWith('.zip')) {
                    if (this.multiple) {
                        // this.unzipAndUpload(file);
                        this.upload(file, this.parentModelType);
                        if (this.extraerImagenesZip) {
                            this.subirImagenesDelZip(file);
                        }
                    } else {
                        this.message = 'Tipo de archivo no válido';
                        this.seleccionando = false;
                    }
                } else {
                    this.upload(file, this.parentModelType);
                }
            });
        }
    }

    private unzipAndUpload(zipFile: File) {
        this.pendientes++;
        let modelos = 0;
        const imagenes = this.extraerImagenesZip ? this.subirImagenesDelZip(zipFile) : Promise.resolve(0);
        const lectura = JSZip.loadAsync(zipFile).then(zip => {
            const filesToUpload: { name: string, content: Blob }[] = [];
            const promises = [];

            zip.forEach((relativePath, zipEntry) => {
                // Con extraerImagenesZip, aquí solo van los modelos 3D: la basura del ZIP y lo que la zona no admite
                // (un .txt daba un 400) no se suben, y las imágenes van aparte, ya comprobadas (subirImagenesDelZip):
                // subirlas también aquí las duplicaría.
                if (this.extraerImagenesZip && (esBasuraDeZip(relativePath) || !tieneExtensionDeModelo3D(relativePath))) {
                    return;
                }
                if (!zipEntry.dir) {
                    const promise = zipEntry.async('blob').then(content => {
                        filesToUpload.push({
                            name: relativePath,
                            content: content
                        });
                    });
                    promises.push(promise);
                }
            });

            return Promise.all(promises).then(() => {
                if (this.extraerImagenesZip && this.destruido) {
                    return;
                }
                modelos = filesToUpload.length;
                filesToUpload.forEach(f => {
                    const file = new File([f.content], f.name);
                    this.upload(file, this.parentModelType);
                });
            });
        });
        lectura.finally(() => this.terminaPendiente());
        if (this.extraerImagenesZip) {
            // Que un ZIP sin nada que subir no se quede en silencio (si no se pudo abrir ya lo dice avisoZip)
            Promise.all([lectura.catch(() => undefined), imagenes]).then(([, numImagenes]) => {
                if (!this.destruido && modelos === 0 && numImagenes === 0 && !this.avisoZip) {
                    this.avisoZip = 'El ZIP no tiene archivos STL, PLY, OBJ ni imágenes JPG, PNG o WEBP: no se ha subido nada de él.';
                }
            });
        }
    }

    /** Sube, una a una como si fueran sueltas, las imágenes que lleve dentro el ZIP. Devuelve cuántas. */
    subirImagenesDelZip(zipFile: File): Promise<number> {
        this.avisoZip = '';
        this.pendientes++;
        return extraerImagenesDeZip(zipFile)
            .then(imagenes => {
                // Si ya se ha salido de la pantalla, subirlas dejaría archivos sin solicitud
                if (this.destruido) {
                    return 0;
                }
                imagenes.forEach(imagen => this.upload(imagen, this.parentModelType));
                return imagenes.length;
            })
            .catch(error => {
                this.avisoZip = error instanceof ZipImagenesError ? error.message : 'No se han podido sacar las imágenes del ZIP.';
                return 0;
            })
            .finally(() => this.terminaPendiente());
    }

    /** Con extraerImagenesZip, avisa al padre cuando ya no queda nada en marcha */
    private terminaPendiente() {
        this.pendientes--;
        if (this.extraerImagenesZip && this.pendientes === 0 && !this.destruido) {
            this.fileUploadedEmmiter.next(this.listaArchivos);
        }
    }

    upload(file: File, type: any): void {
        this.progress = 0;
        let files = [];
        this.message = "";
        if (file) {
            this.pendientes++;
            this.subscriptions.push(this.uploadService.upload(file, type).pipe(finalize(() => {
                this.enviarSeleccion(this.listaArchivos[this.listaArchivos.length - 1]);
                this.terminaPendiente();
            })).subscribe(
                (event: any) => {
                    if (event instanceof HttpResponse) {
                        if (Array.isArray(event.body)) {
                            files = event.body.map(file => {
                                this.interfaceProvider.interfaceForModel(this.modelType).fromPostToModel(file)
                            });
                            this.listaArchivos.push(...files);
                            if (!this.extraerImagenesZip) {
                                this.fileUploadedEmmiter.next(this.listaArchivos);
                            }
                        } else {
                            files.push(this.interfaceProvider.interfaceForModel(this.modelType).fromPostToModel(event.body));
                            this.listaArchivos.push(...files);
                            if (!this.extraerImagenesZip) {
                                this.fileUploadedEmmiter.next(this.listaArchivos);
                            }
                        }
                        this.seleccionando = false;
                        this.cambio.next(this.listaArchivos);
                    }
                },
                (err: any) => {
                    this.progress = 0;
                    if (err.error && err.error.message) {
                        this.message = err.error.message;
                    } else if (err.error && err.error['hydra:description']) {
                        this.message = err.error['hydra:description'];
                    } else {
                        this.message = 'No se ha podido subir el archivo!';
                    }

                    this.seleccionando = false;
                }));
        }
    }


    dropEvent(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const items = event.dataTransfer.items;

        if (items.length === 1 && items[0].kind === 'file') {
            const file = items[0].getAsFile();
            if (file && file.name.toLowerCase().endsWith('.zip')) {
                if (this.multiple) {
                    this.progress = 1;
                    this.unzipAndUpload(file);
                } else {
                    this.message = 'Tipo de archivo no válido';
                    this.progress = 0;
                }
                return;
            }
        }

        this.progress = 1;
        this.subscriptions.push(this.uploadService.proccessDropEventFiles(items).subscribe(file => {
            if (file.name.toLowerCase().endsWith('.zip')) {
                if (this.multiple) {
                    this.unzipAndUpload(file);
                } else {
                    this.message = 'Tipo de archivo no válido';
                    this.progress = 0;
                }
            } else {
                this.upload(file, this.parentModelType);
            }
        }));
    }

    onDragOver(event: DragEvent) {
        event.stopPropagation();
        event.preventDefault();
    }


    update(archivos: any[]) {
        this.listaArchivos.push(...archivos);
    }

    borrar(archivo: any, i, event?: Event) {
        if (this.confirmarBorrado) {
            // Que el clic en el icono no seleccione además la fila (abría la línea del archivo pulsado
            // mientras el padre todavía preguntaba por la que estaba abierta).
            event?.stopPropagation();
            this.fileRemovedEmitter.emit(archivo);
            return;
        }
        this.uploadService.remove(archivo).subscribe(() => {
            this.listaArchivos.splice(i, 1);
            if (this.mostrarVisor) {
                this.enviarSeleccion(this.listaArchivos[i]);
            }
        });
        this.fileRemovedEmitter.emit(archivo)
    }

    borrarTodos() {
        this.listaArchivos.forEach((archivo, index) => this.uploadService.remove(archivo).subscribe(() => {
            if (index === this.listaArchivos.length - 1) {
                this.listaArchivos = [];
                this.enviarSeleccion(null);
            }
        }));
    }

    click(archivo?: any) {
        this.archivoSiguiente = archivo;
        this.clicked.next(archivo)
    }

    enviarSeleccion(archivo?: any) {
        this.archivoSiguiente = null;
        this.seleccionEmmiter.next(archivo);
    }

    nombreFichero(archivo: any) {
        return archivo ? (archivo.nombreFicheroOriginal ?? archivo.nombreFichero) : '';
    }
}
